import _ from 'lodash';
// eslint-disable-next-line import/no-extraneous-dependencies
import Big from 'big.js';

function sumConditionSatisfiersTotal(conditionsManager, discountTaxOrder) {
  let originalTotalPrice = Big(0);
  // Iterate over condition-satisfying products to determine originalTotalPrice and totalQuantity
  _.forEach(conditionsManager.satisfiers, ({ item, quantity }) => {
    const adjustedBasePrice = Big(item.mixAndMatch?.adjustedBasePrice || item.basePrice || 0);
    originalTotalPrice = originalTotalPrice.add(
      // Multiply basePrice by the tax mult to account for taxes in the menu or from POS for taxesFirst setting
      adjustedBasePrice.times(discountTaxOrder === 'taxesFirst' ? item.basePriceMult || 1 : 1).times(quantity)
    );
  });
  return originalTotalPrice;
}

const issueItemsForAPriceRewards = (bogoCalcsData, bogoSpecial, conditionsManager, discountTaxOrder, items) => {
  const { itemsForAPrice, specialId } = bogoSpecial;
  // since we're calling this function again on ln35 we need another check here to make sure we're not dividing by 0
  if (!conditionsManager.satisfied) {
    return {};
  }

  const discountedTotalPrice = Big(itemsForAPrice?.value || 0);
  const originalTotalPrice = sumConditionSatisfiersTotal(conditionsManager, discountTaxOrder);
  const targetIndividualDiscountPercentage = originalTotalPrice.minus(discountedTotalPrice).div(originalTotalPrice);

  // If the discount would raise the price of the items rather than lower it, rerun the conditionsManager without the cheapest item
  if (targetIndividualDiscountPercentage.lt(0)) {
    const itemKeyToRemove = _.keys(conditionsManager.satisfiers)[0];
    const itemsOverride = _.reject(items, ['key', itemKeyToRemove]);
    ({ satisfiers: conditionsManager.satisfiers, satisfied: conditionsManager.satisfied } = conditionsManager.evaluate({
      itemsOverride,
    }));
    return issueItemsForAPriceRewards(bogoCalcsData, bogoSpecial, conditionsManager, discountTaxOrder, itemsOverride);
  }

  const rewardsSatisfiers = {};

  // Iterate over items to determine applicableQuantity & maximum individualDiscount while preserving order
  _.forEach(items, (item) => {
    const conditionSatisfier = conditionsManager.satisfiers[item.key];
    if (!_.isNil(conditionSatisfier)) {
      const { quantity } = conditionSatisfier;
      const adjustedBasePrice = Big(item.mixAndMatch?.adjustedBasePrice || item.basePrice || 0);
      let discount = adjustedBasePrice
        .times(discountTaxOrder === 'taxesFirst' ? item.basePriceMult || 1 : 1)
        .times(targetIndividualDiscountPercentage);

      if (discount.gt(adjustedBasePrice)) {
        discount = adjustedBasePrice;
      }

      const rewardId = itemsForAPrice?._id;

      rewardsSatisfiers[item.key] = {
        item,
        quantity,
        rewards: {
          [rewardId]: {
            quantity,
            reward: {
              _id: rewardId,
              dollarDiscount: Big(discount),
              itemsForAPrice: { ...itemsForAPrice },
            },
            specialId,
          },
        },
      };
    }
  });

  return rewardsSatisfiers;
};

export default issueItemsForAPriceRewards;
